/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".actions-bar__button[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:contents!important}.actions-bar__button[_ngcontent-%COMP%]   .actions-bar__button-icon[_ngcontent-%COMP%]{display:block!important}"];
export { styles as styles };
